<template>
	<div class="m-channel flex-between">
		<div class="advert flex">
			<c-image v-for="(item, i) in advertList" :key="i" class="item" :src="item.img_url"></c-image>	
		</div>
		<div class="channel flex-wrap">
			<div v-for="(item, i) in channelList" :key="i" class="item">
				<div class="title flex-baseline">
					<p>{{item.title}}</p>
					<span>{{item.sub_title}}</span>
				</div>
				<div class="flex-center">
					<c-image class="product" :src="item.img1_url"></c-image>
					<c-image class="product" :src="item.img2_url"></c-image>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				advertList: [],
				channelList: []
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				this.advertList = data.adverts;
				this.channelList = data.channels;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel {
		margin-top: 24px;
		
		.advert {
			.item {
				width: 315px;
				height: 400px;
				background: #fff;
				
				&:nth-child(n+2) {
					margin-left: 10px;
				}
			}
		}
		
		.channel {
			width: 750px;
			
			.item {
				box-sizing: border-box;
				width: 370px;
				height: 195px;
				padding: 0 25px;
				background: #fff;
				
				&:nth-child(n+3) {
					margin-top: 10px;
				}
				
				&:nth-child(even) {
					margin-left: 10px;
				}
				
				.title {
					height: 66px;
					line-height: 66px;
					
					p {
						font-size: 20px;
						font-weight: bold;
					}
					
					span {
						margin-left: 12px;
						font-size: 14px;
						color: #999;
					}
				}
				
				.product {
					width: 120px;
					height: 120px;
					
					&:nth-child(n+2) {
						margin-left: 46px;
					}
				}
			}
		}
	}
</style>
